import { AxiosError } from 'axios';
import { errorMessage } from 'viewup-lib/common';

export const handleDefaultError = (error: unknown) => {
  if (!(error instanceof AxiosError)) {
    return;
  }

  const errorCode = error.response?.data.code;

  if (errorCode === 'auth-009') return;

  if (errorCode === 'auth-010') {
    return;
  }

  if (errorCode) {
    alert(errorMessage[errorCode]);
    return;
  }

  alert('알 수 없는 에러가 발생했습니다.');
};
